import { Modal, Button } from "antd";
import { useTranslation } from "react-i18next";

export default function ReceivedModal({
  visible,
  onCancel,
  onConfirm,
  isAccepted,
}) {
  const { t } = useTranslation();

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      centered
      closable={false}
    >
      <div className="d-flex flex-column align-items-center">
        <h3
          className={`mb-3`}
          style={{
            color: isAccepted ? "#0db14b" : "#ff4242",
          }}
        >
          {isAccepted
            ? t("received.notificationModal.confirmAcceptTitle")
            : t("received.notificationModal.confirmRejectTitle")}
        </h3>
        <p className={"text-center mb-4 fs-5"}>
          {isAccepted
            ? t("received.notificationModal.confirmAcceptMessage")
            : t("received.notificationModal.confirmRejectMessage")}
        </p>

        <div className="d-flex justify-content-end gap-3">
          <Button
            //   type="primary"
            onClick={onCancel}
            className="d-flex align-items-center text-center py-2 px-4 orders__order__offer-btn orders__order__offer-btn--cancel"
          >
            {t("received.notificationModal.cancel")}
          </Button>

          <Button
            onClick={onConfirm}
            className={`d-flex align-items-center text-center py-2 px-4 border-0 orders__order__offer-btn ${
              isAccepted
                ? "orders__order__offer-btn--accept"
                : "orders__order__offer-btn--reject"
            }`}
          >
            {t("storeItems.confirm")}
            {/* {isAccepted
            ? t("received.notificationModal.accept")
            : t("received.notificationModal.reject")} */}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
